class HulaVideoHandler {
  constructor() {
    this.videos = []
    this.init()
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => this.setupVideos())
    } else {
      this.setupVideos()
    }

    // Listen for media changes and other PDP updates
    this.observeMediaChanges()
  }

  setupVideos() {
    const hulaVideos = document.querySelectorAll(".hula-configurator-tool")

    hulaVideos.forEach((video, index) => {
      // Store video reference
      this.videos.push({
        element: video,
        id: `hula-video-${index}`,
        isPlaying: false,
      })

      // Ensure video plays
      this.ensureVideoPlays(video)

      // Add event listeners to maintain playback
      this.addVideoEventListeners(video, index)
    })
  }

  ensureVideoPlays(video) {
    if (video) {
      video.muted = true // Ensure muted for autoplay
      video.loop = true
      video.playsInline = true

      // Force play
      const playPromise = video.play()

      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            console.log("Hula video playing successfully")
          })
          .catch((error) => {
            console.log("Hula video autoplay prevented:", error)
            // Retry after user interaction
            this.retryPlayOnInteraction(video)
          })
      }
    }
  }

  addVideoEventListeners(video, index) {
    // Prevent pausing
    video.addEventListener("pause", (e) => {
      setTimeout(() => {
        if (!video.ended) {
          video.play()
        }
      }, 100)
    })

    // Handle visibility changes
    video.addEventListener("loadeddata", () => {
      this.ensureVideoPlays(video)
    })

    // Update playing status
    video.addEventListener("play", () => {
      this.videos[index].isPlaying = true
    })

    video.addEventListener("pause", () => {
      this.videos[index].isPlaying = false
    })
  }

  retryPlayOnInteraction(video) {
    const playOnInteraction = () => {
      video.play()
      document.removeEventListener("click", playOnInteraction)
      document.removeEventListener("touchstart", playOnInteraction)
    }

    document.addEventListener("click", playOnInteraction)
    document.addEventListener("touchstart", playOnInteraction)
  }

  observeMediaChanges() {
    // Watch for DOM changes that might affect videos
    const observer = new MutationObserver((mutations) => {
      let shouldCheckVideos = false

      mutations.forEach((mutation) => {
        // Check if any nodes were added or removed
        if (mutation.type === "childList") {
          shouldCheckVideos = true
        }

        // Check for attribute changes that might affect media
        if (
          mutation.type === "attributes" &&
          (mutation.attributeName === "class" || mutation.attributeName === "style")
        ) {
          shouldCheckVideos = true
        }
      })

      if (shouldCheckVideos) {
        // Delay to ensure DOM is stable
        setTimeout(() => {
          this.maintainVideoPlayback()
        }, 100)
      }
    })

    // Observe the product media container and surrounding areas
    const mediaContainers = document.querySelectorAll(
      [".product__media", ".product-media", "[data-media]", ".media-gallery", ".product-gallery"].join(", "),
    )

    mediaContainers.forEach((container) => {
      if (container) {
        observer.observe(container, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ["class", "style", "data-media-id"],
        })
      }
    })

    // Also observe the entire product form area
    const productForm = document.querySelector(".product-form, [data-product-form]")
    if (productForm) {
      observer.observe(productForm, {
        childList: true,
        subtree: true,
        attributes: true,
      })
    }
  }

  maintainVideoPlayback() {
    this.videos.forEach((videoData, index) => {
      const video = videoData.element

      // Check if video still exists in DOM
      if (document.contains(video)) {
        // If video was playing, ensure it continues
        if (video.paused && !video.ended) {
          this.ensureVideoPlays(video)
        }
      } else {
        // Video was removed, find new instance
        const newVideo = document.querySelector(`.hula-configurator-tool:nth-of-type(${index + 1})`)
        if (newVideo) {
          this.videos[index].element = newVideo
          this.addVideoEventListeners(newVideo, index)
          this.ensureVideoPlays(newVideo)
        }
      }
    })
  }

  // Public method to force play all videos
  playAllVideos() {
    this.videos.forEach((videoData) => {
      this.ensureVideoPlays(videoData.element)
    })
  }
}

// Initialize when script loads
const hulaHandler = new HulaVideoHandler()

// Expose globally for debugging
window.hulaVideoHandler = hulaHandler

// Handle page visibility changes
document.addEventListener("visibilitychange", () => {
  if (!document.hidden) {
    // Page became visible, ensure videos are playing
    setTimeout(() => {
      hulaHandler.playAllVideos()
    }, 500)
  }
})

// Handle variant changes specifically for Shopify
document.addEventListener("variant:change", () => {
  setTimeout(() => {
    hulaHandler.maintainVideoPlayback()
  }, 200)
})

// Handle any AJAX updates
document.addEventListener("shopify:section:load", () => {
  setTimeout(() => {
    hulaHandler.setupVideos()
  }, 300)
})
